import { getIsAutheticate } from "./Common";
import { Navigate } from "react-router-dom";

export function PrivateRoute({ children, }) {
  try {
    const isAuthenticated = getIsAutheticate();

    if (!isAuthenticated) {
      return <Navigate to="/" />;
    } else {
      return <>{children}</>;
    }

  } catch (error) {
    return <Navigate to="/" />;
  }
}
